import React, { useState } from "react";

const SingleInputForm = (props) => {
  const [value, setValue] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const {
    getCloneIdeaTemplateFn,
    currentTemplateIdPickUp,
    myEmail,
    onSuccess   // ✅ new prop
  } = props || {};

  
  const handleSubmit = (e) => {
    e.preventDefault();
  
    if (!value.trim()) {
      alert("Template Name cannot be empty");
      return;
    }
  
    const objPassForCloneTemplate = {
      id: currentTemplateIdPickUp,
      templateName: value,
      myEmail
    };
  
    getCloneIdeaTemplateFn(objPassForCloneTemplate, () => {
      console.log("Clone success ✅");
      setValue("");
      onSuccess?.();   // ✅ CLOSE DIALOG
    });
  };

  return (
    <form
      onSubmit={handleSubmit}
      style={{ display: "flex", gap: "10px", flexWrap: "wrap" }}
    >
      <input
        type="text"
        value={value}
        onChange={(e) => setValue(e.target.value)}
        placeholder="Enter Template Name..."
        disabled={loading}
        style={{
          width: "100%",
          padding: "14px",
          border: "1px solid #ccc",
          borderRadius: "6px"
        }}
      />

      {error && (
        <p style={{ color: "red", width: "100%" }}>
          {error}
        </p>
      )}

      <button
        type="submit"
        disabled={loading}
        style={{
          padding: "8px 16px",
          backgroundColor: loading ? "#999" : "#007bff",
          color: "#fff",
          border: "none",
          borderRadius: "6px",
          cursor: loading ? "not-allowed" : "pointer"
        }}
      >
        {loading ? "Submitting..." : "Submit"}
      </button>
    </form>
  );
};

export default SingleInputForm;
